import { useParams } from "react-router-dom";
import useSetIsLogin from "../../hooks/useSetIsLogin";
import { useEffect, useState } from "react";
import colors from "../../../config/colors";
import { isExpired, decodeToken } from "react-jwt";
import CustomLabel from "../../components/common/customLabel";

const ConfirmacionBilletera = () => {

    const [expiro, setExpiro] = useState(true);
    const [codigoAfiliado, setCodigoAfiliado] = useState();
    const [fueAgregadoBilletera,setFueAgregadoBilletera] = useState(false)

      let params = useParams();

      const { setAuthLogOut } = useSetIsLogin()
      useEffect(() => {
          setAuthLogOut()
          setExpiro(isExpired(params.token));
      }, [])

      useEffect(() => {
        if (!expiro) {
          const token = params.token;
          const payload = decodeToken(token);
          setCodigoAfiliado(payload.codigoAfiliado);
        }
      }, [expiro]);

    return (
        <div>
          {expiro ? (
          <div
            style={{
              padding: 25,
              display: "flex",
              flexDirection: "column",
              backgroundColor: colors.grayFondo,
              alignItems: "center",
            }}
          >
            <CustomLabel
              style={{
                fontFamily: "montserrat",
                color: colors.primary,
                fontSize: 25,
              }}
            >
              <label>
                El token expiro, favor realizar la solicitud nuevamente.
              </label>
            </CustomLabel>
          </div>
        ) : (<>
        <h1 style={{fontSize: '1rem', textAlign: 'center', color: colors.primary }} >
              Gracias por solicitar el carnet de SeNaSa para la billetera, favor de dar clic al boton de "Agregar a billetera" para terminar el proceso.</h1>
            <div style={{textAlign: 'center'}}>
      <a
        href={`${process.env.REACT_APP_API_URL}Billetera/obtener/archivo/ios?fileName=${codigoAfiliado}`} // URL of the .pkpass file
        download="your-pass.pkpass" 
        target="_blank"
        rel="noopener noreferrer"
        
      >
        <button style={{
          backgroundColor: colors.primary, 
          color: colors.white, 
          fontWeight: 'bold',
          width: '150px',
          height: '40px',
          borderRadius: '5px',
          fontSize: '12px'
          }} onClick={() => {
            setFueAgregadoBilletera(true);
          }} >Agregar a billetera</button>
      </a>
    </div>
    {fueAgregadoBilletera && <div style={{textAlign: 'center'}}>
      <CustomLabel
              style={{
                fontFamily: "montserrat",
                color: colors.primary,
                fontSize: '1rem',
                fontWeight: 'bold',
                marginTop: '50px'
              }}
            >
              <label>
                Favor de dar clic al boton "Redireccionar a billetera" para ver tus billeteras agregadas.
              </label>
            </CustomLabel>
        <button style={{
          backgroundColor: colors.primary, 
          color: colors.white, 
          fontWeight: 'bold',
          width: '150px',
          height: '40px',
          borderRadius: '5px',
          fontSize: '12px',
          marginTop: '10px'
          }}
          onClick={() => {
            const url = 'wallet://'; 
            window.open(url, '_blank'); 
          }} >Redireccionar a billetera</button>

    </div>}
    
        </>)}
            
        </div>
    )
}

export default ConfirmacionBilletera